import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import AddIcon from '@mui/icons-material/Add'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

// Fixed sums paid on top of the shift rate (e.g. £20 vehicle pickup, £10
// food). Controlled editor - `bonuses` is [{label, amount}] and `onChange`
// receives the full replacement array.
const ShiftBonusEditor = ({
  bonuses = [],
  onChange,
  disabled = false,
  currency = '£',
}) => {
  const updateBonus = (index, patch) => {
    onChange(
      bonuses.map((bonus, i) => (i === index ? { ...bonus, ...patch } : bonus)),
    )
  }

  return (
    <Stack spacing={1}>
      {bonuses.map((bonus, index) => (
        <Box key={index} display="flex" gap={1} alignItems="center">
          <TextField
            label="Bonus"
            placeholder="e.g. Vehicle pickup"
            value={bonus.label ?? ''}
            onChange={(e) => updateBonus(index, { label: e.target.value })}
            disabled={disabled}
            size="small"
            fullWidth
          />
          <TextField
            label="Amount"
            type="number"
            value={bonus.amount ?? ''}
            onChange={(e) => {
              const value = e.target.value
              if (value === '') {
                updateBonus(index, { amount: '' })
              } else if (parseFloat(value) >= 0) {
                updateBonus(index, { amount: parseFloat(value) })
              }
            }}
            onWheel={(e) => e.target.blur()}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">{currency}</InputAdornment>
              ),
            }}
            disabled={disabled}
            size="small"
            sx={{ width: 150, flexShrink: 0 }}
          />
          <IconButton
            onClick={() => onChange(bonuses.filter((_, i) => i !== index))}
            disabled={disabled}
            size="small"
            aria-label="Remove bonus"
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Box>
      ))}
      <Box>
        <Button
          startIcon={<AddIcon />}
          onClick={() => onChange([...bonuses, { label: '', amount: '' }])}
          disabled={disabled}
          size="small"
        >
          Add fixed bonus
        </Button>
      </Box>
    </Stack>
  )
}

export default ShiftBonusEditor
